import React, { useMemo, useCallback, useEffect, useState } from 'react';

import { hasLocalStorage } from 'utils/helpers';
import { useCurrentUserId } from 'shared-hooks/user';

const STORAGE_KEY = 'nft_usr';
const EDITOR_VALUE_KEY = 'edtr';
const DEFAULT_EDITOR_VALUE = '';

const getEditorValueKey = id => `${EDITOR_VALUE_KEY}_${id}`;

const saveToStorage = state => {
    if (!hasLocalStorage()) {
        return;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export const UserStorageContext = React.createContext();

export const UserStorageProvider = ({ children }) => {
    const [state, setState] = useState({});
    const userId = useCurrentUserId();


    const saveEditorValue = useCallback((id, value) => {
        if (!id) {
            return;
        }

        setState(prevState => {
            const nextState = {
                ...prevState,
                [getEditorValueKey(id)]: value
            }

            saveToStorage(nextState);

            return nextState;
        });
    }, [setState]);

    const getEditorValue = useCallback(id => {
        if (!id) {
            return DEFAULT_EDITOR_VALUE;
        }

        return state[getEditorValueKey(id)] || DEFAULT_EDITOR_VALUE;
    }, [state]);

    const value = useMemo(() => ({
        saveEditorValue,
        getEditorValue
    }), [saveEditorValue, getEditorValue]);

    useEffect(() => {
        if (userId) {
            if (hasLocalStorage()) {
                try {
                    const stored = localStorage.getItem(STORAGE_KEY);
                    setState(JSON.parse(stored || '{}'));
                } catch (e) {}
            }
        } else {
            setState({});
        }
    }, [userId]);

    return (
        <UserStorageContext.Provider value={value}>
            { children }
        </UserStorageContext.Provider>
    )
};
